<nav-bar>
    <div class="fixed-top" data-toggle="affix">

        <nav ref='nav'
             class="navbar navbar-expand-xl navbar-light animate-menu {'aeroviewer-transparent-menu': !showFilterBar, 'aeroviewer-white-menu': showFilterBar || theme === 'white'}"
             id="aeroviewer-navbar">

            <a class="navbar-brand" href="/">
                <img id="navbar-logo" src="/static/eshop/assets/images/AeroViewer_logo_blue.png" alt="Aeroviewer Logo"
                     class="img-fluid"
                     width="100"
                     height="40">
            </a>

            <div class="navbar-toggler aeroviewer-menu-toggler">
                <i id="navbar-cart" class="fa fa-shopping-cart mr-2" onclick="{onToggleCart}"></i>

                <a href="#" if="{opts.user.id}" data-toggle="dropdown">
                    <i id="navbar-user-icon" class="fa fa-user mr-2"></i>
                </a>

                <div if="{opts.user.id}" class="dropdown-menu dropdown-menu-right aero-dropdown">
                    <div class="d-flex">
                        <img src="/static/eshop/assets/images/user.png" alt="user-icon" class="aero-dropdown-user-icon">
                        <div>
                            <span class="dropdown-header aero-dropdown-title">{opts.user.fullname}</span>
                            <span class="dropdown-header aero-dropdown-sub">{opts.user.email}</span>
                        </div>
                    </div>


                    <div class="dropdown-divider"></div>
                    <a id="navbar-profile" href="/profile" class="dropdown-item text-center">My profile</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-workspace" href="/workspace" class="dropdown-item text-center">Workspace</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-purchases" href="/purchases" class="dropdown-item text-center">My Purchases</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-logout" href="/logout" class="dropdown-item text-center">logout</a>
                </div>

                <a href="#" data-toggle="collapse" data-target="#aeroviewerMenu"
                   aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="fa fa-bars"></i>
                </a>
            </div>

            <div class="collapse navbar-collapse" id="aeroviewerMenu">
                <div class="navbar-nav mr-auto">
                    <a id="navbar-photo" class="nav-item nav-link menu-link" href="/photo-select">
                        Photos
                    </a>
                    <a id="navbar-footage" class="nav-item nav-link menu-link" href="/footage-select">
                        Footage
                    </a>
                    <a id="navbar-recording" class="nav-item nav-link menu-link" href="/recording/create"
                       onclick="{checkIfMobile}">
                        Video Recorder
                    </a>
                    <a id="navbar-collection" class="nav-item nav-link menu-link" href="/collection-select">
                        Collections
                    </a>
                    <a id="navbar-digishare" class="nav-item nav-link menu-link" href="/digishare">
                        DigiShare
                    </a>
                    <a id="navbar-pricing" class="nav-item nav-link menu-link" href="/pricing">
                        Pricing
                    </a>
                </div>
                <hr class="menu-hr d-lg-none">
                <div class="navbar-nav">
                    <a id="navbar-contact" class="nav-item nav-link menu-link" href="/contact">Contact Us</a>
                    <a id="navbar-contributors" class="nav-item nav-link menu-link"
                       href="/contributors">Contributors</a>
                    <!--                    <a class="nav-item nav-link menu-link" href="/pricing">Pricing</a>-->
                    <a id="navbar-about" class="nav-item nav-link menu-link" href="/about">About</a>

                </div>
                <a class="nav-item nav-link menu-link d-none d-lg-block" onclick="{onToggleCart}" href="/">
                    <div class="shopping-cart-container">
                        <span if="{total}" class="notification-bubble">{total}</span>
                        <i class="fa fa-shopping-cart fa-2x"></i>
                    </div>
                </a>
                <!-- Login Button -->
                <a id="navbar-sign-in" if="{!opts.user.id}" class="btn btn-sm menu-login-btn d-none d-lg-block mr-2"
                   href="{resolveLogin()}">Sign In</a>
                <a id="navbar-sign-up" if="{!opts.user.id}" class="btn btn-sm menu-login-btn d-none d-lg-block"
                   href="/signup">Sign Up</a>

                <!-- Mobile Login Button -->
                <a id="navbar-sign-up-mobile" if="{!opts.user.id}"
                   class="btn btn-lg menu-login-btn w-100 d-lg-none mb-3" href="/signup">Sign
                    Up</a>
                <a id="navbar-sign-in-mobile" if="{!opts.user.id}" class="btn btn-lg menu-login-btn w-100 d-lg-none"
                   href="{resolveLogin()}">Sign In</a>

                <a if="{opts.user.id}" class="nav-item nav-link menu-link d-none d-lg-block" data-toggle="dropdown"
                   href="#">
                    <i class="fa fa-user fa-2x"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right aero-dropdown">
                    <div class="d-flex">
                        <img src="/static/eshop/assets/images/user.png" alt="user-icon" class="aero-dropdown-user-icon">
                        <div>
                            <span class="dropdown-header aero-dropdown-title">{opts.user.fullname}</span>
                            <span class="dropdown-header aero-dropdown-sub">{opts.user.email}</span>
                        </div>
                    </div>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-dropdown-profile" href="/profile" class="dropdown-item text-center">My Profile</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-dropdown-workspace" href="/workspace" class="dropdown-item text-center">Workspace</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-dropdown-purchases" href="/purchases" class="dropdown-item text-center">My
                        Purchases</a>

                    <div class="dropdown-divider"></div>
                    <a id="navbar-dropdown-logout" href="/logout" class="dropdown-item text-center">logout</a>
                </div>
            </div>
        </nav>

        <nav if="{showFilterBar}" class="navbar navbar-expand-lg navbar-light aeroviewer-white-menu filter-menu">

            <a class="navbar-brand" href="#">{opts.namespace || ''}</a>

            <div class="navbar-toggler aeroviewer-menu-toggler">
                <tagging-search
                        if="{!showTextSearch}"
                        selection-list="{[]}"
                        selected-list="{activeFilters()}"
                        scoped-tags="{[]}"
                        ref="desktopTagging"
                        on-select="{onTagChange}"
                        ajax="{taggingAPI}"
                ></tagging-search>

                <text-search
                        if="{showTextSearch}"
                        on-search="{onSearch}"
                        term="{opts.query.search}"
                ></text-search>


                <filter-sorting
                        if="{showFilterMenu}"
                        on-filter="{onFilter}"
                >
                </filter-sorting>
            </div>


            <div class="collapse navbar-collapse" id="aeroviewerFilterMenu">
                <div class="navbar-nav mr-auto">

                    <tagging-search
                            if="{!showTextSearch}"
                            ref="mobileTagging"
                            selection-list="{[]}"
                            selected-list="{activeFilters()}"
                            scoped-tags="{[]}"
                            on-select="{onMobileTagChange}"
                            ajax="{taggingAPI}"
                    ></tagging-search>

                    <text-search
                            if="{showTextSearch}"
                            on-search="{onSearch}"
                            term="{opts.query.search}"
                    ></text-search>
                </div>
                <div class="navbar-nav">
                    <filter-sorting
                            if="{showFilterMenu}"
                            on-filter="{onFilter}"
                    >
                    </filter-sorting>
                    <a id="filter-bar-show-map" if="{!hideMap}" onclick="{onToggleMap}"
                       class="btn btn-sm menu-login-btn d-none d-lg-block">Show
                        Map</a>
                </div>
            </div>
        </nav>

        <cart
                total="{total}"
                price="{price}"
                items="{items}"
                service="{cartSrv}"
        ></cart>

    </div>

    <script>
        // import external libraries
        import swal from 'sweetalert';

        // import styles
        import './nav-bar.css';

        // import tags
        import './filter-sorting.tag.html';
        import './cart.tag.html';
        import './tag-search.tag.html';
        import './text-search.tag.html';

        // import services

        import {cartService} from "../../services/cart/service.es6";

        const tag = this;

        // setup cartService
        tag.cartSrv = cartService({
            container: tag,
            namespace: 'store/cart'
        });

        tag.addItem = tag.cartSrv.addItem;
        tag.removeItem = tag.cartSrv.removeItem;
        tag.getCart = tag.cartSrv.getCart;
        tag.taggingAPI = `/v1.1/${opts.tagApi || 'footage'}/tags/list`;

        //
        tag.showFilterBar = opts.showFilterBar || false;
        tag.hideMap = opts.hideMap || false;
        tag.theme = opts.theme || 'transparent';
        tag.showFilterMenu = opts.showFilterMenu || false;
        tag.showTextSearch = opts.showTextSearch || false;

        //
        tag.hideMenu = () => {
            if (window.pageYOffset > 10) {
                tag.navBar.addClass('d-none');
            } else {
                tag.navBar.removeClass('d-none');
            }
        };

        //
        tag.toggleNavClass = () => {
            if (window.pageYOffset > 10) {
                tag.navBar.removeClass('aeroviewer-transparent-menu');
                tag.navBar.addClass('aeroviewer-light-dark-menu');
            } else {
                tag.navBar.removeClass('aeroviewer-light-dark-menu');
                tag.navBar.addClass('aeroviewer-transparent-menu');
            }
        };

        tag.resolveLogin = () => {
            return `/login?next=${window.location.href}`.replace(window.eshop, '')
        };


        tag.logout = (event) => {
            event.preventUpdate = true;
            event.preventDefault();
            window.location.href = '/logout'
        };

        tag.activeFilters = () => {
            if (opts.query.filtering.length)
                return opts.query.filtering[0].value;
            else
                return []
        };

        // navbar event actions

        tag.onToggleMap = (event) => {
            event.preventDefault();
            event.preventUpdate = true;

            if (opts.onToggleMap)
                opts.onToggleMap()
        };

        tag.onToggleCart = (event) => {
            event.preventDefault();
            event.preventUpdate = true;
            tag.tags.cart.toggleCart();
        };

        tag.onTagChange = (event) => {
            if (event) {
                event.preventDefault();
                event.preventUpdate = true;
            }

            if (opts.onActionStart)
                opts.onActionStart();

            let tagSearch = [...tag.refs.desktopTagging.getValues()];

            console.log('Desktop Tagging: ', tag.refs.desktopTagging.getValues());

            if (tagSearch.length) {

                console.log(opts.search);

                opts.search({
                    filtering: [{
                        name: 'tags',
                        operator: 'contains',
                        value: tagSearch
                    }],
                    sortedBound: opts.query.sortedBound,
                    sorting: opts.query.sorting
                });
            } else {
                opts.search({});
            }

            if (opts.onActionEnd)
                opts.onActionEnd();

        };

        tag.onMobileTagChange = (event) => {
            if (event) {
                // event.preventDefault();
                event.preventUpdate = true;
            }

            if (opts.onActionStart)
                opts.onActionStart();

            let tagSearch = [...tag.refs.mobileTagging.getValues()];

            console.log('Mobile Tagging: ', tag.refs.mobileTagging.getValues());

            if (tagSearch.length) {

                opts.search({
                    filtering: [{
                        name: 'tags',
                        operator: 'contains',
                        value: tagSearch
                    }],
                    sortedBound: opts.query.sortedBound,
                    sorting: opts.query.sorting
                });
            } else {
                opts.search({});
            }

            if (opts.onActionEnd)
                opts.onActionEnd();

        };

        tag.onSearch = (term) => {
            if (opts.onActionStart)
                opts.onActionStart();
            opts.search({
                filtering: opts.query.filtering,
                sortedBound: opts.query.sortedBound,
                search: term,
                sorting: opts.query.sorting
            })
        };

        tag.onFilter = (_filtering) => {
            if (opts.onActionStart)
                opts.onActionStart();

            let filtering = (!_filtering.length) ? [] : [{
                name: 'type',
                operator: 'in',
                value: _filtering
            }];

            console.log(filtering);

            opts.search({
                filtering: filtering,
                sortedBound: opts.query.sortedBound,
                search: opts.query.search,
                sorting: opts.query.sorting
            })
        };


        // lifecycle methods
        tag.on('mount', () => {
            // Cart service
            console.log(tag.taggingAPI, opts.tagApi);

            tag.cartSrv.getCart();

            // UI event binding and handling

            tag.navBar = $(tag.refs.nav);
            tag.navBarCollapse = $('.collapse');

            if (tag.showFilterBar === false)
                tag.toggleNavClass();
            else
                tag.hideMenu();

            window.onscroll = function () {
                if (tag.showFilterBar === false)
                    tag.toggleNavClass();
                else
                    tag.hideMenu();

            };

            tag.navBarCollapse.on('show.bs.collapse', function () {
                tag.navBar.toggleClass('bg-navbar-collapse-show');
            });

            tag.navBarCollapse.on('hidden.bs.collapse', function () {
                tag.navBar.toggleClass('bg-navbar-collapse-show');
            });
        });

        tag.checkIfMobile = (event) => {
            if ('screen' in window && window.screen.width < 768) {
                event.preventDefault();

                swal({
                    title: 'Mobile view',
                    text: 'This functionality is disabled in mobile.',
                    icon: 'warning'
                })
            }
        }
    </script>
</nav-bar>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/nav-bar/nav-bar.tag.html